/** Shared UI state only; the existing export component owns data loading and serialization. */
export const headerDownloadTopic = (page: string, segment = ''): string =>
  `header-download:${page || ''}:${segment || ''}`;
